export default function (...args)
{
	/** Radio marcado no DOM (estado checked). Seletor pode apontar para o grupo (ex.: .sort_order). */
	const checkedValueFromDom = (selector) =>
		document.querySelector(`${selector}:checked`)?.value;

	return {

		events: ['change'],

		getValue(default_value = checkedValueFromDom(this.selector), _this = this)
		{
			return this.safeProtoCall(default_value, _this);
		},

		refresh()
		{
			let selected = this.getValue();
			let nodes = document.querySelectorAll(this.selector);
			nodes.forEach(node =>
			{
				node.checked = (String(node.value) === String(selected));
			});
		},

		/** Evita que syncFromDom() do field pegue só o 1º radio e force Ascendente (value 0). #MT-18DD133 */
		syncFromDom()
		{
			const v = checkedValueFromDom(this.selector);
			if (v !== undefined && v !== null)
				this.setValue(v);
		},

		handleEvents(ev)
		{
			this.setValue(ev.target.value);
			this.refresh();
		}

	};
}

